<Page>
  <Navbar title="No encontrado" backLink="Back" />
  <Block strong>
    <p>Lo siento</p>
    <p>El contenido solicitado no se encontró.</p>
  </Block>
</Page>
<script>
  import { Page, Navbar, Block } from 'framework7-svelte';
</script>